import { Autocomplete, TextField } from "@mui/material";
import { Component } from "react";
import { httpGet, httpPost } from "../util/http";

export default class UsuarioSelect extends Component {
    constructor(props) {
        super(props)
        this.state = {
            items: [],
            loading: false,
        }
    }

    componentDidMount() {
        this.setState({ loading: true });
        httpGet('/inventarios/users/' + this.props.unidadeId,
            usuarios => {
                this.setState({
                    items: usuarios,
                    loading: false
                });
            },

            error => {
                console.log(error);
                this.setState({ loading: false });
            },

            true //salva no cache
        );
    }

    render() {
        return (
            <Autocomplete {...this.props.props}
                noOptionsText="Nenhum usuário"
                loadingText="Carregando..."
                openText="Abrir lista"
                loading={this.state.loading}
                value={this.props.value} options={this.state.items}
                size="small"
                sx={{
                    ...this.props.sx,
                    // '& fieldset': { borderRadius: 10 }, borderRadius: 10
                }}
                getOptionLabel={option => option.nome}
                getOptionKey={option => option.id}
                onChange={(e, value) => this.props.onChange ? this.props.onChange(value) : {}}
                isOptionEqualToValue={(option, value) => { return option.id === value.id }}
                renderInput={(params) => <TextField
                    {...params}
                    error={this.props.error === true}
                    helperText={this.props.error === true ? "Escoha um usuário" : null}
                    label={'Usuários' + (this.props.required ? '*' : '')} />}
            />
        );
    }
}